export default "__VITE_PUBLIC_ASSET__fc69f0f2__"